import { TextColorTypes, BackgroundColorTypes } from '@/Fonts/FontTypes'
/**
 * SPORT1 REFRESH TODO: TO BE DELETED (ENTIRE FILE)
 */
export type ColorsMapType = {
    [key: string]: TextColorTypes | undefined
}

export const backgroundToFontColorMap: ColorsMapType = {
    onyx: 'pearl',
    'keshi-3': 'pearl',
    'onyx-3': 'WHITE',
    ORANGE: 'WHITE',
    'moon-2': 'onyx',
    'moon-3': 'onyx',
    'tahitian-4': 'onyx',
    pearl: 'onyx',
    error: 'WHITE',
    WHITE: 'BLACK',
    BLACK: 'WHITE',
}

export function getFontColorByBackgroundColor(
    backgroundColor: BackgroundColorTypes
): TextColorTypes | undefined {
    return backgroundToFontColorMap[backgroundColor]
}
